import { COLORS } from '@constants';
import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    background: ${COLORS.$gray10Black};
`;
